import { IUpdateProjetoRevisaoUseCase } from "../../../presentation/useCases/update/update_projeto_revisao_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * UpdateProjetoRevisaoUseCase
 */

export class UpdateProjetoRevisaoUseCase implements IUpdateProjetoRevisaoUseCase {
  constructor(private readonly repository: IProjetosRepository) { }

  async execute(
    idProjetoRevisao: number,
    status?: number,
    idFuncionarioAprovacao?: number,
    observacoesAprovacao?: string,
    dataAprovacao?: Date,
    dataTermino?: Date,

  ): Promise<void> {
    return await this.repository.updateProjetoRevisao(
      idProjetoRevisao,
      status,
      idFuncionarioAprovacao,
      observacoesAprovacao,
      dataAprovacao,
      dataTermino,
    );

  }
}
